import { AbstractControl, ValidatorFn } from '@angular/forms';

export function phoneIntegerValidator(): ValidatorFn {
   return (control: AbstractControl): { [key: string]: any } | null => {
      const value = control.value;
      const isInteger = Number.isInteger(Number(value));
      return isInteger ? null : { notInteger: { value } };
   };
}
